import { Navigate } from 'react-router-dom';
import { usePlatformAuth } from '../context/PlatformAuthContext';
import { LoadingScreen } from '../components/LoadingScreen';

export function PlatformProtectedRoute({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isLoggedIn, isLoading } = usePlatformAuth();

  if (isLoading) return <LoadingScreen />;
  if (!isLoggedIn) return <Navigate to="/platform/login" replace />;

  return <>{children}</>;
}
